'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactImage = require('react-image');

var _reactImage2 = _interopRequireDefault(_reactImage);

var _reactContainerDimensions = require('react-container-dimensions');

var _reactContainerDimensions2 = _interopRequireDefault(_reactContainerDimensions);

var _Loader = require('./Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _AnimatedGradient = require('./AnimatedGradient');

var _AnimatedGradient2 = _interopRequireDefault(_AnimatedGradient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
// eslint-disable-line import/no-extraneous-dependencies


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions

/** Returns a random number between min (inclusive) and max (exclusive) */
var getRandomArbitrary = function getRandomArbitrary(min, max) {
  return Math.random() * (max - min) + min;
};
var random = Math.round(getRandomArbitrary(1, 100));

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
var image = (0, _glamor.css)({
  width: '100%',
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  background: '#F2F2F2',
  border: '1px solid #EAEAEA',

  '& img': {
    width: 'inherit',
    height: 'inherit'
  }
});
var imageClass = image.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Fade on Load
var keyframes = _glamor.css.keyframes({
  '0%': { opacity: '0.7' },
  '100%': { opacity: '1' }
});
var keyframesName = keyframes.toString();

var imageLoaded = (0, _glamor.css)({
  display: 'block',
  animationName: '' + keyframesName,
  animationDuration: '300ms',
  animationTimingFunction: 'cubic-bezier(0.77, 0, 0.175, 1)'
});
var imageLoadedClass = imageLoaded.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/** Image */

var Image = function (_React$Component) {
  _inherits(Image, _React$Component);

  /**
   * [constructor description]
   * @param  {[type]} props [description]
   * @return {[type]}       [description]
   */
  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      imageLoaded: false
    };

    _this.imageLoaded = _this.imageLoaded.bind(_this);
    return _this;
  }

  /**
   * [imageLoaded description]
   * @return {[type]} [description]
   */


  Image.prototype.imageLoaded = function imageLoaded() {
    this.setState({
      imageLoaded: true
    });
  };

  /**
   * [render description]
   * @return {[type]} [description]
   */


  Image.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        givenClassName = _props.className,
        _props$containerStyle = _props.containerStyle,
        containerStyle = _props$containerStyle === undefined ? {} : _props$containerStyle,
        _props$imgStyle = _props.imgStyle,
        imgStyle = _props$imgStyle === undefined ? {} : _props$imgStyle,
        style = _props.style,
        _props$rawWidth = _props.rawWidth,
        rawWidth = _props$rawWidth === undefined ? 1440 : _props$rawWidth,
        _props$rawHeight = _props.rawHeight,
        rawHeight = _props$rawHeight === undefined ? 900 : _props$rawHeight,
        src = _props.src,
        alt = _props.alt,
        loader = _props.loader,
        gradientPreset = _props.gradientPreset,
        onClick = _props.onClick,
        _props$ratio = _props.ratio,
        ratio = _props$ratio === undefined ? rawHeight / rawWidth : _props$ratio;

    var imageId = 'image-' + random;

    return _react2.default.createElement(
      _reactContainerDimensions2.default,
      null,
      function (_ref) {
        var _classNames;

        var width = _ref.width;

        var imageHeight = Math.round(width * ratio);
        return _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)(imageClass, givenClassName),
            style: _extends({
              height: imageHeight,
              width: '100%'
            }, style, containerStyle)
          },
          _react2.default.createElement(_reactImage2.default, {
            id: imageId,
            src: src,
            alt: alt,
            loader: loader === 'gradient' ? _react2.default.createElement(
              'div',
              { style: { height: imageHeight, width: '100%' } },
              _react2.default.createElement(_AnimatedGradient2.default, { preset: gradientPreset })
            ) : _react2.default.createElement(
              'div',
              {
                style: {
                  height: imageHeight,
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }
              },
              _react2.default.createElement(_Loader2.default, null)
            ),
            onLoad: function onLoad() {
              return _this2.imageLoaded();
            },
            className: (0, _classnames2.default)((_classNames = {}, _classNames[imageLoadedClass] = _this2.state.imageLoaded, _classNames)),
            onClick: onClick,
            style: _extends({}, imgStyle)
          })
        );
      }
    );
  };

  return Image;
}(_react2.default.Component);

// ------------------------------------------------------------------------------
// ------------------------------------------------------------------------Typing
// ------------------------------------------------------------------------------


Image.propTypes = process.env.NODE_ENV !== "production" ? {
  src: _propTypes2.default.string,
  alt: _propTypes2.default.string,
  rawWidth: _propTypes2.default.number,
  rawHeight: _propTypes2.default.number,
  ratio: _propTypes2.default.number,
  loader: _propTypes2.default.string,
  gradientPreset: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  className: _propTypes2.default.string,
  imgStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  containerStyle: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
} : {};

Image.defaultProps = {
  alt: 'An image',
  rawWidth: 1440,
  rawHeight: 900,
  loader: 'spinner',
  gradientPreset: 'gray',
  style: {},
  imgStyle: {},
  containerStyle: {},
  className: ''

  // ------------------------------------------------------------------------------
  // ----------------------------------------------------------------------- Export
  // ------------------------------------------------------------------------------
};exports.default = Image;
module.exports = exports['default'];